var map = {
	"./add.svg": "5110",
	"./bells.svg": "ec3b",
	"./businessCenter.svg": "79b7",
	"./close.svg": "864a",
	"./copyright.svg": "7de1",
	"./coupon_bg.svg": "0543",
	"./down.svg": "1a4e",
	"./head-bg.svg": "668d",
	"./head.svg": "583e",
	"./icon1.svg": "ad0e",
	"./icon2.svg": "c97b",
	"./icon3.svg": "8329",
	"./icon4.svg": "14cb",
	"./icon5.svg": "cbe6",
	"./icon6.svg": "938c",
	"./icon7.svg": "6fc4",
	"./icon8.svg": "b923",
	"./js.svg": "7574",
	"./logo.svg": "d9b6",
	"./manger.svg": "6204",
	"./more.svg": "d5d3",
	"./personnel.svg": "7958",
	"./software.svg": "1471",
	"./super.svg": "b612",
	"./tip.svg": "6c05",
	"./toggle-left.svg": "107f",
	"./toggle-right.svg": "da32"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";